import { graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect } from "react"
import Loader from "react-loader-spinner"
import Button from "../../../shared/components/atoms/button/button"
import {
  ORGID,
  RECORDTYPE,
  WebToCaseUrl,
} from "../../../shared/constants/api-constants"
// import ContactService from '../../../shared/services/contact-service'
import { siteUrl } from "../../../shared/utils/siteUrl"
import { Helmet } from 'react-helmet';
import * as reCaptchaKey from '../../../shared/constants/reCaptcha';
import "./form-question-web-to-case.scss"
import DataPolicy from "../../../shared/components/atoms/data-policy/data-policy"
import UseChecksPolicy from "../../../shared/hooks/useChecksPolicy"
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'

const DOCUMENT_OPTIONS = {
  "es-AR": ["DNI","CI"],
  "es-BO": ["CI"],
  "es-CL": ["CI"],
  "es-CO": ["TI", "CE", "CC"],
  "es-EC": ["CI"],
  "es-PY": ["CI"],
  "es-PE": ["DNI"],
  "es-PR": ["ID"],
  "es-DO": ["CIE"],
  "es-UY": ["CI"],
}

const FormQuestion = (titleForm) => {
  const locale = process.env.LOCALE || "es-CO"
  const [listStates, setListStates] = useState([])
  const [listCities, setListCities] = useState([])

  const [
    selectIdentificationTypeOpen,
    setSelectIdentificationTypeOpen,
  ] = useState(false)
  const [selectStateOpen, setSelectStateOpen] = useState(false)
  const [selectCityOpen, setSelectCityOpen] = useState(false)

  const [identificationType, setIdentificationType] = useState()
  const [countryStateSelected, setCountryStateSelected] = useState()
  const [citySelected, setCitySelected] = useState()

  const [isFormSend, setIsFormSend] = useState(false)

  const [locationError, setLocationError] = useState(false)

  const ADRESS_QUERY_FORM = useStaticQuery(
    graphql`
      query ADRESS_QUERY_FORM {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            codigoIcu
            departamentos {
              codigo
              nombre
            }
            ciudades {
              codigo
              codigoDepartamento
              nombre
            }
          }
        }
        allContentfulNolContactanos {
          nodes {
            node_locale
            checksLegales {
             tituloPrincipal
              redireccion
              idPrincipal
      
            }
          }
        }
      }
    `
  )

  const checkLegalesInfo = ADRESS_QUERY_FORM.allContentfulNolContactanos.nodes.filter(v => v.node_locale === process.env.LOCALE)[0].checksLegales

  const options = [
    {
      name: "Agradecimiento",
      value: "AGRADECIMIENTO",
    },
    {
      name: "Actualización datos personales",
      value: "ACTUALIZACION_DATOS",
    },
    {
      name: "Reclamo Producto Nosotras",
      value: "RECLAMO_PRODUCTO",
    },
    {
      name: "Solicitud de información",
      value: "SOLICITUD_INFORMACION_CONTACTO",
    },
    {
      name: "Sugerencia",
      value: "SUGERENCIA_CONTACTO",
    },
    {
      name: "Otro motivo",
      value: "OTRO_MOTIVO",
    },
    // <option value="No le llega notificaciÃ³n pedido">No le llega notificaciÃ³n pedido</option>
    // <option value="No le llega la factura">No le llega la factura</option>
    // <option value="Retracto de compra">Retracto de compra</option>
    // <option value="Empaque primario deteriorado">Empaque primario deteriorado</option>
    // <option value="Accesorios pdcto deteriorados">Accesorios pdcto deteriorados</option>
    // <option value="Producto deteriorado">Producto deteriorado</option>
    // <option value="Actitud del caballero">Actitud del caballero</option>
    // <option value="Se genero un daÃ±o">Se genero un daÃ±o</option>
    // <option value="Actitud de el conductor">Actitud de el conductor</option>
    // <option value="Mala atenciÃ³n en la LÃ­nea">Mala atenciÃ³n en la LÃ­nea</option>
    // <option value="Inconformidad con mi distribuidor">Inconformidad con mi distribuidor</option>
    // <option value="Inconformidad con el ejecutivo Familia">Inconformidad con el ejecutivo Familia</option>
    // <option value="Otros">Otros</option>
    // <option value="No llego completo">No llego completo</option>
    // <option value="Referencias equivocadas">Referencias equivocadas</option>
    // <option value="Demora en entrega">Demora en entrega</option>
    // <option value="Producto deteriorado en tte">Producto deteriorado en tte</option>
    // <option value="Legales">Legales</option>
    // <option value="Sugerencias">Sugerencias</option>
    // <option value="Sostenibilidad">Sostenibilidad</option>
    // <option value="Portafolio de empresas">Portafolio de empresas</option>
    // <option value="CaracterÃ­sticas del producto">CaracterÃ­sticas del producto</option>
    // <option value="Portafolio disponible">Portafolio disponible</option>
    // <option value="Fichas tÃ©cnicas">Fichas tÃ©cnicas</option>
    // <option value="Quiero sticker o campaÃ±as de cultura">Quiero sticker o campaÃ±as de cultura</option>
  ]

  const [activeSelect, setactiveSelect] = useState(false)
  const homeLink = siteUrl + "/"

  const mailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

  const defaultusernameValue = ""
  const defaultmailValue = ""
  const defaultphoneValue = ""
  const defaultactiveOption = { name: "Selecciona el motivo", value: "" }
  const defaultquestionValue = ""

  const [activeLoader, setactiveLoader] = useState(false)
  const [showSuccessQuestion, setshowSuccessQuestion] = useState(false)

  /* ---------- Input values ----------- */
  const [usernameValue, setusernameValue] = useState(defaultusernameValue)
  const [mailValue, setmailValue] = useState(defaultmailValue)
  const [phoneValue, setphoneValue] = useState(defaultphoneValue)
  const [activeOption, setactiveOption] = useState(defaultactiveOption)
  const [questionValue, setquestionValue] = useState(defaultquestionValue)
  /* ---------- Input values ----------- */

  /* ---------- Error flags ----------- */
  const [usernameError, setusernameError] = useState(false)
  const [mailError, setmailError] = useState(false)
  const [phoneError, setphoneError] = useState(false)
  const [optionError, setoptionError] = useState(false)
  const [questionError, setquestionError] = useState(false)
  const [tycError, settycError] = useState(false)
  /* ---------- Error flags ----------- */

  /* ---------- Error Values ----------- */
  const [mailErrorValue, setmailErrorValue] = useState("")
  const [phoneErrorValue, setphoneErrorValue] = useState("")
  /* ---------- Error Values ----------- */

  const dataLayerContacto = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Contactanos',
      category: 'contactanos',
      action: 'click',
      label: 'Enviar pregunta',
      sub_category: 'Preguntas frecuentes',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  // checks for data policy
 const {checks, changeCheck, isAllChecksTrue, getPayloadCheck} = UseChecksPolicy(false, checkLegalesInfo)
  const handleSubmit = (e) => {
    e.preventDefault()
    if (!haveErrors() && !isDefaultValues()) {
      const form = document.getElementById("f-form-question")
      dataLayerContacto()
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'gaEvent',
        'eventTrigger': 'ContactUs',
        'eventCategory': 'Form',
        'eventAction': 'Submit',
        'eventLabel': 'Contact Us',
        'eventValue': undefined
      });
      setTimeout(() => {
        // handleSubmitHabeasData()
        form.submit()
        setIsFormSend(true)
      }, 500);
    }
  }

  const handleSubmitData = e => {
    e.preventDefault()
    if (!haveErrors() && !isDefaultValues()) {
      setactiveLoader(true)
    }
  }


  // const handleSubmitHabeasData = () => {
  //   if (localStorage.getItem("TOKEN_INFO") !== null) {
  //     const token = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
  //     const config = {
  //       headers: {
  //         Authorization: token,
  //       },
  //     }
  //     DataPolicyService.updatePolicy(getPayloadCheck(), config)
  //       .then(res => {
  //         console.log('Habeas data update')
  //       })
  //   }

  // }


  const handleChangeChecks = (e, index) => {
    changeCheck(index,e.target.checked)
  }

  const handleReset = () => {
    setusernameValue(defaultusernameValue)
    setmailValue(defaultmailValue)
    setphoneValue(defaultphoneValue)
    setactiveOption(defaultactiveOption)
    setquestionValue(defaultquestionValue)
    setshowSuccessQuestion(false)
    setactiveLoader(false)
  }

  const isDefaultValues = () => {
    return (
      defaultusernameValue === usernameValue &&
      defaultmailValue === mailValue &&
      defaultphoneValue === phoneValue &&
      defaultactiveOption === activeOption &&
      defaultquestionValue === questionValue
    )
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const haveErrors = () => {
    /* ----- draw errors ----- */


    if (isAllChecksTrue()) {
      settycError(true)
    } else {
      settycError(false)
    }

    if (usernameValue === "" || usernameValue === " ") {
      setusernameError(true)
    } else {
      setusernameError(false)
    }

    if (phoneValue === "") {
      setphoneError(true)
      setphoneErrorValue("*Este campo es requerido")
    } else {
      if (mistakeCellByCountry(phoneValue)) {
        setphoneError(true)
        setphoneErrorValue("*Número inválido")
      } else {
        setphoneError(false)
      }
    }

    if (mailValue === "") {
      setmailError(true)
      setmailErrorValue("*Este campo es requerido")
    } else if (!mailRegex.test(mailValue)) {
      setmailError(true)
      setmailErrorValue("*Correo inválido")
    } else {
      setmailError(false)
    }

    if (activeOption.name === "Selecciona el motivo") {
      setoptionError(true)
    } else {
      setoptionError(false)
    }

    if (questionValue === "" || questionValue === " ") {
      setquestionError(true)
    } else {
      setquestionError(false)
    }

    /* ----- draw errors ----- */

    /* ----- function flag ----- */
    return (
      isAllChecksTrue() ||
      usernameValue === "" ||
      usernameValue === " " ||
      (phoneValue === "" ? true : mistakeCellByCountry(phoneValue)) ||
      mailValue === "" ||
      !mailRegex.test(mailValue) ||
      activeOption.name === "Selecciona el motivo" ||
      questionValue === "" ||
      questionValue === " "
    )
    /* ----- function flag ----- */
  }

  useEffect(() => {
    let url_string = window.location.href
    let url = new URL(url_string)
    let section = url.searchParams.get("c")
    if (section === "y") {
      setshowSuccessQuestion(true)
    }
  }, [])

  const timestamp = () => {
    let response = document.getElementById("g-recaptcha-response");
    if (response == null || response.value.trim() == "" || !isFormSend) {
      let elems = JSON.parse(document.getElementsByName("captcha_settings")[0].value);
      elems["ts"] = JSON.stringify(new Date().getTime());
      document.getElementsByName("captcha_settings")[0].value = JSON.stringify(elems);
    }
  }

  useEffect(() => {
    let states = ADRESS_QUERY_FORM.allContentfulNolPaises.nodes.filter(
      e => e.codigoIcu === process.env.LOCALE
    )[0].departamentos
    setListStates(() => states)
    let captchaInterval = setInterval(timestamp, 2000);
    () => {
      clearInterval(captchaInterval);
    }
  }, [])

  return (
    <section className="f-question-section f-question-section--web-to-case">
      <Helmet>
        <meta HTTP-EQUIV="Content-type" CONTENT="text/html; charset=UTF-8" />
        <script src="https://www.google.com/recaptcha/api.js" async defer></script>
      </Helmet>
      <div className="f-section-position">
        {showSuccessQuestion ? (
          <div className="f-success-question">
            <label className="f-success-title">Pregunta enviada</label>
            <p className="f-success-description">
              <span className="f-bold">Gracias por enviarnos tu pregunta,</span>{" "}
              pronto recibirás la respuesta.
            </p>
            <div onClick={handleReset}>
              <Button
                title="Preguntar otra vez"
                className="primary-blue alter fit"
              />
            </div>
          </div>
        ) : (
          <>
            <div className="f-title-container">
              <label className="f-title">
                ¿No encontraste lo que buscabas?
                <span className="f-pink-section">
                  {process.env.LOCALE === "es-PY"
                    ? "preguntanos"
                    : "pregúntanos"}
                </span>
              </label>
            </div>

            <form
              onSubmit={handleSubmitData}
              id="f-form-question"
              className="f-form-question"
              action={WebToCaseUrl}
              method="POST"
              autoComplete="off"
            >
              {/* <!-- Estos campos siempre debe ir en todos los formularios --> */}
              <input type="hidden" name='captcha_settings' value='{"keyname":"NolV2","fallback":"true","orgId":"00D3j0000001yNQ","ts":""}' />
              <input
                type="hidden"
                name="retURL"
                value={homeLink + "contactanos/?c=y"}
              />
              <input type="hidden" name="orgid" value={ORGID} />
              <input type="hidden" name="recordType" value={RECORDTYPE} />
              <input type="hidden" name="Origin" value="Site" />
              <input
                type="hidden"
                id="00N3j00000GUNs8"
                name="00N3j00000GUNs8"
                value={process.env.COUNTRY_NAME.toUpperCase()}
              />
              <input
                type="hidden"
                id="00N3j00000GUT2O"
                maxLength="255"
                name="00N3j00000GUT2O"
                size="200"
                value={homeLink + "contactanos"}
              />
              <p hidden>
                <select id="status" name="status">
                  <option value="GRF_PendienteTipificacion">
                    GRF_PendienteTipificacion
                  </option>
                </select>
                {/* <!-- Marca: --> */}
                <select name="GRF_Marca__c" title="Marca">
                  <option value="Nosotras">Nosotras</option>
                </select>
              </p>
              {/* <!-- hasta aqui los campos que siempre debe ir en todos los formularios --> */}
              <div className="f-input-group">
                <label className="f-input-label">TIPO DE IDENTIFICACIÓN</label>
                <div
                  className={"f-input-question f-fake-select "}
                  onClick={() => {
                    setSelectIdentificationTypeOpen(true)
                  }}
                >
                  <label className="f-label-inside">{identificationType}</label>
                  <input
                    type="hidden"
                    id="00N3j00000GUNsa"
                    name="00N3j00000GUNsa"
                    value={identificationType}
                  />
                  <span className="f-icon icon-down" />
                  {selectIdentificationTypeOpen && (
                    <ul className="f-collapse-menu">
                      {DOCUMENT_OPTIONS[locale].map(option => {
                        return (
                          <li
                            className="f-item-option"
                            key={option}
                            onClick={e => {
                              e.stopPropagation()
                              setIdentificationType(option)
                              setSelectIdentificationTypeOpen(false)
                            }}
                          >
                            {option}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              </div>
              <div className="f-input-group">
                <label className="f-input-label" htmlFor="name">
                  NÚMERO DE IDENTIFICACIÓN
                </label>
                <input
                  type="number"
                  className={"f-input-question"}
                  id="00N3j00000GUNs5"
                  name="00N3j00000GUNs5"
                />
              </div>
              <div className="f-input-group">
                <label className="f-input-label" htmlFor="name">
                  TU NOMBRE
                </label>
                <input
                  type="text"
                  className={
                    "f-input-question " + (usernameError ? "input-error" : "")
                  }
                  name="name"
                  id="name"
                  value={usernameValue}
                  onChange={e => {
                    setusernameValue(e.target.value.replace(/ {2}/g, " "))
                  }}
                />
                {usernameError && (
                  <label className="f-label-error">
                    *Este campo es requerido
                  </label>
                )}
              </div>
              <div className="f-input-group">
                <label className="f-input-label" htmlFor="email">
                  TU CORREO
                </label>
                <input
                  value={mailValue}
                  type="text"
                  className={
                    "f-input-question " + (mailError ? "input-error" : "")
                  }
                  name="email"
                  id="email"
                  onChange={e => {
                    setmailValue(e.target.value.replace(/ /g, ""))
                  }}
                />
                {mailError && (
                  <label className="f-label-error">{mailErrorValue}</label>
                )}
              </div>
              <div className="f-input-group">
                <label className="f-input-label" htmlFor="phone">
                  TU NÚMERO CELULAR
                </label>
                <input
                  type="text"
                  className={
                    "f-input-question " + (phoneError ? "input-error" : "")
                  }
                  id="phone"
                  name="phone"
                  maxLength={process.env.MAX_DIGITS}
                  value={phoneValue}
                  onChange={e => {
                    setphoneValue(e.target.value.replace(/\D/, ""))
                  }}
                />
                {phoneError && (
                  <label className="f-label-error">{phoneErrorValue}</label>
                )}
              </div>
              <div className="f-input-group">
                <label className="f-input-label">MOTIVO DE CONSULTA</label>
                <div
                  className={
                    "f-input-question f-fake-select " +
                    (optionError ? "input-error" : "")
                  }
                  onClick={() => setactiveSelect(true)}
                >
                  <label className="f-label-inside">{activeOption.name}</label>
                  <input
                    type="hidden"
                    id="type"
                    name="type"
                    value={activeOption.value}
                  />
                  <span className="f-icon icon-down" />
                  {optionError && (
                    <label className="f-label-error option-label">
                      *Elije una opción
                    </label>
                  )}

                  {activeSelect && (
                    <ul className="f-collapse-menu">
                      {options.map((option, index) => {
                        return (
                          <li
                            className="f-item-option"
                            key={index}
                            onClick={e => {
                              e.stopPropagation()
                              setactiveSelect(false)
                              setactiveOption(option)
                            }}
                          >
                            {option.name}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              </div>
              <div className="f-input-group">
                <label className="f-input-label">DEPARTAMENTO</label>
                <div
                  className={"f-input-question f-fake-select "}
                  onClick={() => {
                    setSelectCityOpen(false)
                    setSelectStateOpen(true)
                  }}
                >
                  <label className="f-label-inside">
                    {countryStateSelected}
                  </label>
                  <input
                    type="hidden"
                    id="countryState"
                    name="countryState"
                    value={countryStateSelected}
                  />
                  <span className="f-icon icon-down" />
                  {locationError && (
                    <label className="f-label-error option-label">
                      *Elije una opción
                    </label>
                  )}

                  {selectStateOpen && (
                    <ul className="f-collapse-menu">
                      {listStates.map(option => {
                        return (
                          <li
                            className="f-item-option"
                            key={option["codigo"]}
                            onClick={e => {
                              e.stopPropagation()
                              setCountryStateSelected(option["nombre"])
                              let citiesFiltered = ADRESS_QUERY_FORM.allContentfulNolPaises.nodes
                                .filter(
                                  e => e.codigoIcu === process.env.LOCALE
                                )[0]
                                .ciudades.filter(item => {
                                  return (
                                    item["codigoDepartamento"] ==
                                    option["codigo"]
                                  )
                                })
                              setListCities(() => citiesFiltered)
                              setCitySelected()
                              setSelectStateOpen(false)
                              setSelectCityOpen(false)
                            }}
                          >
                            {option["nombre"]}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              </div>
              <div className="f-input-group">
                <label className="f-input-label">CIUDAD</label>
                <div
                  className={"f-input-question f-fake-select "}
                  onClick={() => {
                    setSelectCityOpen(true)
                    setSelectStateOpen(false)
                  }}
                >
                  <label className="f-label-inside">{citySelected}</label>
                  <input
                    type="hidden"
                    id="00N3j00000GUNqr"
                    name="00N3j00000GUNqr"
                    value={citySelected}
                  />
                  <span className="f-icon icon-down" />
                  {locationError && (
                    <label className="f-label-error option-label">
                      *Elije una opción
                    </label>
                  )}

                  {selectCityOpen && (
                    <ul className="f-collapse-menu">
                      {listCities.map(option => {
                        return (
                          <li
                            className="f-item-option"
                            key={option["codigo"]}
                            onClick={e => {
                              e.stopPropagation()
                              setCitySelected(option["nombre"])
                              setSelectStateOpen(false)
                              setSelectCityOpen(false)
                            }}
                          >
                            {option["nombre"]}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              </div>
              <div className="f-input-group f-textarea-group">
                <label className="f-input-label">TU PREGUNTA</label>
                <textarea
                  type="text"
                  className={
                    "f-textarea-question " +
                    (questionError ? "input-error" : "")
                  }
                  id="description"
                  name="description"
                  maxLength="300"
                  value={questionValue}
                  onChange={e => {
                    setquestionValue(e.target.value.replace(/ {2}/g, " "))
                  }}
                ></textarea>
                {questionError && (
                  <label className="f-label-error">
                    *Este campo es requerido
                  </label>
                )}
              </div>

              <div className="f-button-input-group">
                <div className="f-step-question-checkBox-group">

                  {checkLegalesInfo.map((item, index) => {
                    // si es distinto a mis puntos
                    if(item.idPrincipal !== "pbAccepted"){
                      return(
                        <div className="f-step-question-form-checkBox" key={item.idPrincipal}>
                          <input
                            onChange={e => {
                              handleChangeChecks(e, index)

                            }}
                            type="checkbox"
                            name={item.idPrincipal}
                            id={item.idPrincipal}
                            value="1"
                          />
                          <p className="f-step-question-form-checkBox-copy">
                            <a
                              className="f-step-question-form-link"
                              rel="noopener noreferrer"
                              target="_blank"
                              href={homeLink + item.redireccion}
                            >
                              {item.tituloPrincipal}
                            </a>
                          </p>
                          <span className="f-checkmark"></span>
                        </div>
                      )
                    }
                  })}

                  {tycError &&
                    <label className="f-label-error">
                      *Debes aceptar para continuar
                    </label>
                  }

                  <DataPolicy />
                </div>
                <div
                  className="g-recaptcha"
                  data-sitekey={reCaptchaKey.keyV2}
                ></div>
                <div className="f-button-container">
                  {activeLoader ? (
                    <Loader
                      type="TailSpin"
                      color="#FF409B"
                      height={50}
                      width={50}
                    />
                  ) : (
                    <div>
                      <button
                        className="primary-blue alter fit"
                        data-callback='handleSubmit'
                        onClick={handleSubmit}
                      >
                        Enviar pregunta
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </section>
  )
}

export default FormQuestion
